import { getLeadRef } from "@/lib/leadRef";

// Telefoonnummer: één bron van waarheid. Elementen met het nummer krijgen class "js-phone",
// zodat later een call-tracking nummer kan worden ingewisseld.
export const PHONE_DISPLAY = "085 060 1864";
export const PHONE_E164 = "+31850601864";
export const TEL_LINK = `tel:${PHONE_E164}`;

// KvK-nummer: één centrale instelling. Leeg = de KvK-regel wordt nergens getoond.
export const KVK_NUMBER = "";

const wa = (msg) => `https://wa.me/31850601864?text=${encodeURIComponent(msg)}`;

// Belangrijk: de lead_ref wordt NIET meer tijdens render in de href gebakken
// (dat brak SSG-hydratie, React #418), maar pas bij de klik zelf — zie App.js.
export const withLeadRef = (href) =>
  href.includes("(ref ") ? href : href + encodeURIComponent(` (ref ${getLeadRef()})`);

const WA_BASE = "Hallo, ik heb een lekkage en wil graag zo snel mogelijk hulp. Mijn postcode is …";
const WA_PHOTO_BASE = "Hallo, ik stuur een foto van de lekkage. Mijn postcode is …";

export const waLink = () => wa(WA_BASE);
export const waPhotoLink = () => wa(WA_PHOTO_BASE);

export const HERO_IMAGE = "/img/foto/hero-team-1200.webp";
export const HERO_SRCSET = "/img/foto/hero-team-640.webp 640w, /img/foto/hero-team-960.webp 960w, /img/foto/hero-team-1200.webp 1200w, /img/foto/hero-team.webp 1920w";
export const INDUSTRIAL_IMAGE = "/img/vakman-leiding.webp";
export const WATER_DROP_IMAGE = "/img/waterdruppel.webp";
export const IMG_OVERLEG = "/img/overleg.webp";
export const IMG_VAKMENSEN = "/img/vakmensen.webp";
export const IMG_INSPECTIE = "/img/inspectie.webp";
export const IMG_HERSTEL = "/img/herstel.webp";
export const IMG_TEAM_MARIJN = "/team-marijn.webp";
export const IMG_TEAM_DANNY = "/team-danny.webp";
export const IMG_TEAM_MAOUI = "/team-maoui.webp";
